import script from "./OpportunitiesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OpportunitiesSection.vue?vue&type=script&setup=true&lang=js"

import "./OpportunitiesSection.vue?vue&type=style&index=0&id=5d8c28cb&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d8c28cb"]])

export default __exports__